import React, { useEffect, useRef, useState } from "react";
import { ExclamationCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Radio, Row, Select, Switch, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { Back } from "../../components/Icons/Icons";
import usePartnerName from "../../hooks/usePartnerName";
import { setPartner, setPartnerId } from "../../Reducer/localStorageSlice";
import "./OrgOnboarding.scss";
import { inputFieldCharLimit } from "../../config";

const organisationSize = [
  { value: "MICRO", label: 'Micro 0-9' },
  { value: "SMALL", label: 'Small 10-49' },
  { value: "MEDIUM", label: 'Medium 50-249' },
  { value: "LARGE", label: 'Large 249+' },
]

export default function OnboardingPage() {
  const localData = useSelector((state) => state?.localStorage)
  const radioGroupRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [postalCode, setPostalCode] = useState('');
  const editData = location?.state?.data

  const { partnerId } = localData
  const [partnerLogo, setPartnerLogo] = useState(null);
  const [, setFormData] = useState();
  const [, setCountries] = useState([]);
  const [, setFormFilled] = useState(false);
  const [member, setMember] = useState(false);
  const { formattedName: partner } = usePartnerName()
  const [partnerID, setPartnerID] = useState(partnerId);
  const [orgSize, setOrgSize] = useState(() => {
    try {
      return editData?.size || sessionStorage.getItem("size") || null;
    } catch (e) {
      return null;
    }
  })
  const [form] = Form.useForm();



  const handlePrev = () => {
    if (radioGroupRef.current) {
      radioGroupRef.current.scrollLeft -= 150;
    }
  };

  const handleNext = () => {
    if (radioGroupRef.current) {
      radioGroupRef.current.scrollLeft += 150;
    }
  };

  const is1920 = useMediaQuery({ width: 1920 });
  const is1366 = useMediaQuery({ width: 1366 });
  const is1240 = useMediaQuery({ width: 1024 });
  const is1680 = useMediaQuery({ width: 1680 });
  const is1600 = useMediaQuery({ width: 1600 });
  const is1280 = useMediaQuery({ width: 1280 });
  const is800 = useMediaQuery({ width: 800 });
  const is820 = useMediaQuery({ width: 820 });
  const is768 = useMediaQuery({ width: 768 });
  const is320 = useMediaQuery({ width: 320 });
  const is375 = useMediaQuery({ width: 375 });
  const is412 = useMediaQuery({ width: 412 });
  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
  const labelColSpan =
    is1366 || is1680 || is1600
      ? 6
      : is1920
        ? 8
        : is1240
          ? 7
          : is1280
            ? 8
            : is800
              ? 7
              : 8;

  const paddingTop = is1920
    ? "10px"
    : is1366
      ? "10px"
      : is320 || is1240
        ? "5px"
        : is375 || is820 || is412 || isSmallScreen
          ? "6px"
          : is768
            ? "4px"
            : "1px";

  const [allOrgTypes, setAllOrgTypes] = useState([]);

  const getOnOrganisationType = async () => {
    try {
      const response = await getRequest(
        userapiservice.getOnOrganisationType(partnerID)
      );
      if (response) {
        setAllOrgTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPartnerLogo = async (partner) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      setPartnerLogo(response);
      setPartnerID(response.id)
      dispatch(setPartnerId(response?.id))
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getCountriesList = async () => {
    try {
      const response = await getRequest(userapiservice.getCountries());
      setCountries(response);
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  useEffect(() => {
    if (editData) {
      console.log('i am inside', editData)
      setAllOrgTypes(editData?.allOrgTypes)
    }
  }, [editData])

  useEffect(() => {
    if (editData && form) {
      form.setFieldsValue({
        size: editData?.size || sessionStorage.getItem("size") || null,
        type: editData?.typeId || undefined,
      });
      setOrgSize(editData?.size || sessionStorage.getItem("size") || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, form]);

  const submitHandler = (values) => {
    setFormData(values);

    let formData = {
      addressStreet: values?.addressStreet,
      email: values?.email,
      isActiveMember: member,
      name: values?.name,
      phone: values?.phone,
      postcode: values?.postcode,
      size: values?.size,
      typeId: values?.type,
      userName: values?.userName,
      websiteLink: values?.websiteLink,
      allOrgTypes
    };
    sessionStorage.setItem("adr", values?.addressStreet);
    sessionStorage.setItem("email", values?.email);
    sessionStorage.setItem("isactive", member);
    sessionStorage.setItem("name", values?.name);
    sessionStorage.setItem("phone", values?.phone);
    sessionStorage.setItem("postcode", values?.postcode);
    sessionStorage.setItem("size", values?.size);
    sessionStorage.setItem("userName", values?.userName);
    sessionStorage.setItem("webLink", values?.websiteLink);
    const typeName =
      allOrgTypes.find((type) => type.id === formData.typeId)?.displayName || "";
    sessionStorage.setItem("typeId", values?.type);
    sessionStorage.setItem("type", typeName);
    navigate("/terms", {
      state: {
        formData,
        partnerLogo: partnerLogo?.siteName,
        nameType: typeName,
      },
    });
    setFormFilled(true);
  };

  const validatePostalCode = (value) => {
      if (!value) return Promise.reject("Postal code is required");

  // Global postal code pattern
  const postalCodeRegex = /^[A-Za-z0-9\s\-]{3,12}$/;

  if (!postalCodeRegex.test(value)) {
    return Promise.reject("Please enter a valid postal code");
  }

  return Promise.resolve();
  };

  useEffect(() => {
    getOnOrganisationType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(sessionStorage.getItem("postcode")) {
      setPostalCode(sessionStorage.getItem("postcode"));
    }

  },[sessionStorage])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('partnerId')) {
      setPartnerID(urlParams.get('partnerId'))
    }
  }, [])

  useEffect(() => {

    if (partner) {
      getPartnerLogo(partner)
      dispatch(setPartner(partner))
    }
    if (partnerID) {
      getOnOrganisationType(partnerID)
      dispatch(setPartnerId(partnerID))

    }
    getCountriesList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, partnerID])

  useEffect(() => {
    partner && getPartnerLogo(partner);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  useEffect(() => {
    getCountriesList();
  }, [])

  useEffect(() => {
    const storedSwitchValue = sessionStorage.getItem("isactive");
    if (storedSwitchValue !== null) {
      setMember(storedSwitchValue === "true");
    }
  }, []);



  const handleBack = () => {
    // If we are currently on /onboarding and the previous page was /term → skip it
    const prevPath = document.referrer; // gives you the previous URL

    if (location.pathname === "/onboarding" && prevPath.includes("/term")) {
      // 🚀 Instead of going back to /term, go back 2 steps if possible
      if (window.history.state && window.history.state.idx > 1) {
        navigate(-2);
      } else {
        // fallback if no history
        navigate("/");
      }
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1); // normal back
    } else {
      navigate("/"); // fallback home (or onboarding if you prefer)
      sessionStorage.clear();
    }
  };

  return (
    <motion.div
      className="onboarding-background-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="onboarding-header">
        <div className="back-arrow" onClick={handleBack}>
          <Back />
        </div>
        <div className="join-name">
          {/* {partnerLogo?.siteName && `Apply to join "${partnerLogo?.siteName}"`} */}
          Apply to join

        </div>
      </div>
      <div className="onBoard-container">
        <div className="form-container">
          <Form
            form={form}
            className="signup-form"
            initialValues={{
              // type: sessionStorage.getItem("typeId")
              //   ? sessionStorage.getItem("typeId")
              //   : allOrgTypes.length > 0
              //     ? allOrgTypes[0]?.id
              //     : "",
              type: editData?.typeId ? editData?.typeId

                : allOrgTypes.length > 0
                  ? allOrgTypes[0]?.id
                  : "",
              isActiveMember: sessionStorage.getItem("isactive")
                ? sessionStorage.getItem("isactive")
                : false,
              name: sessionStorage.getItem("name")
                ? sessionStorage.getItem("name")
                : "",
              addressStreet: sessionStorage.getItem("adr")
                ? sessionStorage.getItem("adr")
                : "",
              postcode: sessionStorage.getItem("postcode")
                ? sessionStorage.getItem("postcode")
                : postalCode || "",
              size: sessionStorage.getItem("size")
                ? sessionStorage.getItem("size")
                : null,
              userName: sessionStorage.getItem("userName")
                ? sessionStorage.getItem("userName")
                : "",
              email: sessionStorage.getItem("email")
                ? sessionStorage.getItem("email")
                : "",
              phone: sessionStorage.getItem("phone")
                ? sessionStorage.getItem("phone")
                : "",
              websiteLink: sessionStorage.getItem("webLink")
                ? sessionStorage.getItem("webLink")
                : "",
            }}
            onFinish={submitHandler}
          >


            <div className="formInfoStyle">
              <div className="formInfoRow">
                <div className="formInfoCol">
                  {allOrgTypes?.length >= 3 ? (
                    <Form.Item
                      className="form-item orgType"
                      label="Organisation type"
                      name="type"
                      rules={[
                        {
                          required: true,
                          message: "Organisation type is required",
                        },
                      ]}
                    >
                      <div style={{ position: "relative" }}>
                        {/* Left Arrow Button */}
                        <div
                          onClick={handlePrev}
                          style={{
                            position: "absolute",
                            left: "-20px",
                            top: "20px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 10,
                            padding: "5px",
                            background: "transparent",
                          }}
                        >
                          <LeftOutlined
                            style={{ fontSize: "15px", color: "#1890ff" }}
                          />
                        </div>

                        {/* Radio Group with Scroll */}
                        <Radio.Group
                          className="orgTypeBtns"
                          buttonStyle="solid"
                          ref={radioGroupRef}
                          style={{
                            display: "flex",
                            overflowX: "hidden",
                            whiteSpace: "nowrap",
                            paddingBottom: "10px",
                          }}
                        >
                          {allOrgTypes?.length > 0
                            ? allOrgTypes.map((type) => (
                              <Radio.Button
                                key={type.id}
                                value={type.id}
                                style={{
                                  width: "auto",
                                  flexShrink: 0, // Prevent buttons from shrinking
                                }}
                              >
                                {type?.displayName}
                              </Radio.Button>
                            ))
                            : null}
                        </Radio.Group>

                        {/* Right Arrow Button */}
                        <div
                          onClick={handleNext}
                          style={{
                            position: "absolute",
                            right: '-20px',
                            top: "20px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 1,
                            padding: "5px",
                            background: "transparent",
                          }}
                        >
                          <RightOutlined
                            style={{ fontSize: "14px", color: "#1890ff" }}
                          />
                        </div>
                      </div>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      className="form-item orgType"
                      // style={{marginLeft:"0px",width:"99%"}}
                      label="Organisation type"
                      name="type"
                      rules={[
                        {
                          required: true,
                          message: "Organisation type is required",
                        },
                      ]}
                    >
                      <Radio.Group
                        className="orgTypeBtns"
                        buttonStyle="solid"
                        style={{
                          paddingLeft: "0px",
                          width:
                            is1366 || is1240 || is768 || is820 ? "100%" : "99%",
                          gap:
                            is1366 && allOrgTypes.length === 3
                              ? "3vw"
                              : is1366 && allOrgTypes.length > 3
                                ? "1vw"
                                : is1240
                                  ? "3vw"
                                  : is768
                                    ? "2vw"
                                    : is820
                                      ? "2vw"
                                      : "1vw",
                        }}
                      >
                        {allOrgTypes?.length > 0
                          ? allOrgTypes.map((type) => (
                            <Radio.Button
                              key={type.id}
                              value={type.id}
                              style={{ width: "auto", paddingLeft: '1%', paddingRight: '1%' }}
                            >
                              {type?.displayName}
                            </Radio.Button>
                          ))
                          : null}
                      </Radio.Group>
                    </Form.Item>
                  )}
                </div>
              </div>
              <div className="formInfoRow existing_mem_row">
                <div className="formInfoCol existing_mem_col">
                  <Form.Item
                    className="switch-item memberFormItem switch_exist"
                    // style={{ marginTop: "10vw" }}
                    label="Are you an existing member"
                    name="isActiveMember"
                    rules={[
                      {
                        required: true,
                        message: "Choose if you are member or not",
                      },
                    ]}
                  >
                    <div className="flexSwitch">
                      <Switch
                        // style={{ color: "green" }}
                        className="memberSwitch"
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        // defaultChecked={false}
                        checked={member}
                        onChange={(e) => {
                          if (e) {
                            setMember(true);
                          } else {
                            setMember(false);
                          }
                        }}
                      />
                      <div className="memberCondition custom-placeholder">{`${partnerLogo?.name ? partnerLogo?.name : ""
                        }`}</div>
                    </div>
                  </Form.Item>

                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField org-name"
                    label="Organisation name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Organisation name is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Organisation name"
                      className="custom-placeholder"
                      maxLength={inputFieldCharLimit}
                    // style={{ border: "1px solid #7E97B8",height:"55px", }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField"
                    label="Address"
                    name="addressStreet"
                    rules={[{ required: true, message: "Address is required" }]}
                  >
                    <TextArea
                      style={{ paddingTop: paddingTop }}
                      className="addressBox custom-placeholder"
                      rows={1}
                      placeholder="Full address (You need to be in our catchment area)"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField"
                    label="Postal code"
                    name="postcode"
                    rules={[
                      {
                        required: true,
                        validator: (_, value) => validatePostalCode(value),
                        message: "Please enter a valid postal code",
                      },
                    ]}
                  >
                    <div className="d-flex align-items-center">
                      <Input
                      value={postalCode}
                        // style={{ border: "1px solid #7E97B8",height:"55px"  }}
                        className="addressBox custom-placeholder"
                        rows={1}
                        placeholder="Postal code"
                        maxLength={inputFieldCharLimit}
                        onChange={(e) => setPostalCode(e.target.value)}
                      />
                      <Tooltip title="Enter your postal code">
                        <ExclamationCircleOutlined style={{ marginLeft: 8, fontSize: "20px", color: '#3067ae', position: 'absolute', right: '-25px', top: '5px' }} />
                      </Tooltip>

                    </div>
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item organisationSize"
                    label="Organisation size"
                    name="size"
                    rules={[
                      {
                        required: true,
                        message: "Organisation size is required",
                      },
                    ]}
                  >


                    <Select
                      className="orgSize1"
                      placeholder="Select Organization Size"
                      onChange={(value) => {
                        setOrgSize(value);
                        try {
                          form.setFieldsValue({ size: value });
                        } catch (e) {
                          // ignore
                        }
                      }}
                    >
                      {organisationSize.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField"
                    label="Full name"
                    name="userName"
                    rules={[
                      { required: true, message: "Full name is required" },
                      {
                        pattern: new RegExp(/^[a-zA-Z_ ]*$/),
                        message:
                          "Field does not accept numbers or special characters",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Full name"
                      className="custom-placeholder"
                      maxLength={inputFieldCharLimit}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField"
                    label="Email"
                    normalize={(value) => value?.trim()}
                    name="email"
                    rules={[
                      { required: true, message: "Email is required" },
                      { type: "email", message: "Enter valid email" },
                    ]}
                  >
                    <Input
                      // style={{ border: "1px solid #7E97B8",height:"55px"  }}
                      placeholder="Email"
                      className="custom-placeholder"
                      maxLength={inputFieldCharLimit}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item adrField"
                    label="Phone number"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Phone number is required",
                      },
                      {
                        pattern: /^[0-9\s]+$/,
                        message: "Please enter only numbers.",
                      },
                    ]}
                  >
                    <Input
                      // style={{ border: "1px solid #7E97B8",height:"55px"  }}
                      placeholder="Phone number"
                      className="custom-placeholder"
                      maxLength={12}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="form-item"
                    label="Organisation website"
                    name="websiteLink"
                  >
                    <Input
                      // style={{ border: "1px solid #7E97B8",height:"55px"  }}
                      placeholder="Website"
                      className="custom-placeholder"
                      maxLength={inputFieldCharLimit}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Button
                    // style={{ width: '186px'}}
                    type="primary"
                    htmlType="submit"
                    className="next_button"
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>


          </Form>
          {/* </Row> */}
        </div>
        {/* <div className="submitBtn">
          <Button
            // style={{ width: '186px'}}
            type="primary"
            htmlType="submit"
            className="next_button"
          >
            Next
          </Button>
        </div> */}
      </div>
    </motion.div>
  );
}
